module.exports = __webpack_public_path__ + "img/rullet_cobe.90b1b5a1.png";